import { render, staticRenderFns } from "./zyGoodsList.vue?vue&type=template&id=7565a0f0&scoped=true"
import script from "./zyGoodsList.vue?vue&type=script&lang=js"
export * from "./zyGoodsList.vue?vue&type=script&lang=js"
import style0 from "./zyGoodsList.vue?vue&type=style&index=0&id=7565a0f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7565a0f0",
  null
  
)

export default component.exports